import { render, staticRenderFns } from "./additionalMaintenance.vue?vue&type=template&id=36861c1b&scoped=true&"
import script from "./additionalMaintenance.vue?vue&type=script&lang=ts&"
export * from "./additionalMaintenance.vue?vue&type=script&lang=ts&"
import style0 from "./additionalMaintenance.vue?vue&type=style&index=0&id=36861c1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36861c1b",
  null
  
)

export default component.exports